const messagesInGerman = {
    financialServices: "Finanzdienstleistungen",
  };
  
  export { messagesInGerman };
  